(function () {
  if (window.kutufixCollectionPagination) return;
  window.kutufixCollectionPagination = true;

  const automaticLimit = 96;
  const historyKey = 'kutufixCollectionPagination';
  const savedState = history.state?.[historyKey];
  const shouldRestore = performance.getEntriesByType('navigation')[0]?.type === 'back_forward'
    && savedState?.url === window.location.href && Number.isSafeInteger(savedState.pages) && savedState.pages > 0;
  let loading = false;
  let restoring = shouldRestore;
  let observedGrid = null;
  let currentList = null;
  let entryUrl = window.location.href;
  let loadedPages = 0;
  let scrollTimer;
  const intersectionObserver = typeof window.IntersectionObserver === 'function'
    ? new IntersectionObserver((entries) => {
        const link = getAutomaticLink();
        if (entries.some((entry) => entry.isIntersecting && entry.target === link)) loadNextPage();
      }, { rootMargin: '0px 0px 800px 0px' })
    : null;
  const gridObserver = new MutationObserver(observeNextPage);

  function getGrid() {
    return document.getElementById('CollectionProductGrid');
  }

  function getAutomaticLink() {
    const grid = getGrid();
    const link = grid?.querySelector('[data-infinite-scrolling]');
    const count = grid?.querySelectorAll('.productListing > .product').length || 0;
    const nextCount = Number(link?.dataset.nextPageCount);
    return !loading && !restoring && grid?.querySelector('.pagination-infinite')
      && nextCount > 0 && count + nextCount <= automaticLimit ? link : null;
  }

  function saveHistory() {
    if (restoring || window.location.href !== entryUrl || getGrid()?.querySelector('.productListing') !== currentList) return;
    const anchor = [...(currentList?.children || [])].find((card) => {
      const bounds = card.getBoundingClientRect();
      return bounds.bottom > 0 && bounds.top < window.innerHeight;
    });
    history.replaceState({
      ...history.state,
      [historyKey]: {
        url: entryUrl, pages: loadedPages, scrollY: window.scrollY,
        anchor: anchor?.querySelector('[data-product-id]')?.dataset.productId,
        anchorOffset: anchor?.getBoundingClientRect().top
      }
    }, '');
  }

  function observeNextPage() {
    const grid = getGrid();
    if (grid !== observedGrid) {
      gridObserver.disconnect();
      observedGrid = grid;
      if (grid) gridObserver.observe(grid, { childList: true, subtree: true });
    }
    const list = grid?.querySelector('.productListing');
    if (list !== currentList) {
      currentList = list;
      loadedPages = 0;
      entryUrl = window.location.href;
    }
    if (!intersectionObserver) return;
    intersectionObserver.disconnect();
    const link = getAutomaticLink();
    if (link) intersectionObserver.observe(link);
  }

  function loadNextPage() {
    const grid = getGrid();
    const link = grid?.querySelector('[data-infinite-scrolling]');
    const list = grid?.querySelector('.productListing');
    const section = grid?.closest('.shopify-section');
    if (!link || !list || !section || loading) return false;

    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || !destination.searchParams.has('page')) return false;
    const requestUrl = new URL(destination);
    requestUrl.searchParams.set('section_id', section.id.replace(/^shopify-section-/, ''));
    const start = grid.querySelector('[data-total-start]')?.textContent;
    const isCurrentList = () => list.isConnected && getGrid()?.querySelector('.productListing') === list;
    loading = true;
    link.classList.add('is-loading');
    link.setAttribute('aria-busy', 'true');

    return fetch(requestUrl, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(String(response.status));
        return response.text();
      })
      .then((html) => {
        if (!isCurrentList()) return false;
        const nextGrid = new DOMParser().parseFromString(html, 'text/html').getElementById('CollectionProductGrid');
        const cards = nextGrid?.querySelectorAll('.productListing > .product');
        const navigation = grid.querySelector('.pagination');
        const nextNavigation = nextGrid?.querySelector('.pagination');
        if (!cards?.length || !navigation || !nextNavigation) throw new Error('Invalid collection response');
        cards.forEach((card) => list.appendChild(document.adoptNode(card)));
        navigation.replaceWith(document.adoptNode(nextNavigation));
        const startCounter = grid.querySelector('[data-total-start]');
        if (startCounter && start) startCounter.textContent = start;
        loadedPages += 1;
        saveHistory();
        const functions = window.sharedFunctions || {};
        if (window.wishlist?.show) functions.setLocalStorageProductForWishlist?.();
        functions.swapHoverVideoProductCard?.();
        return true;
      })
      .catch(() => {
        if (isCurrentList()) window.location.href = destination.href;
        return false;
      })
      .finally(() => {
        loading = false;
        link.classList.remove('is-loading');
        link.removeAttribute('aria-busy');
        observeNextPage();
      });
  }

  async function restoreList(event) {
    if (event?.persisted || !shouldRestore) {
      restoring = false;
      observeNextPage();
      return;
    }
    const list = currentList;
    for (let page = 0; page < savedState.pages; page += 1) {
      if (currentList !== list || window.location.href !== savedState.url || !await loadNextPage()) break;
    }
    restoring = false;
    if (currentList === list && window.location.href === savedState.url && loadedPages === savedState.pages) {
      requestAnimationFrame(() => {
        if (currentList !== list || window.location.href !== savedState.url) return;
        const anchor = [...list.children].find((card) => card.querySelector('[data-product-id]')?.dataset.productId === savedState.anchor);
        const top = anchor ? window.scrollY + anchor.getBoundingClientRect().top - savedState.anchorOffset : savedState.scrollY;
        window.scrollTo({ top, behavior: 'instant' });
        saveHistory();
      });
    }
    observeNextPage();
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest?.('#CollectionProductGrid a[href*="/products/"]')) saveHistory();
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('#CollectionProductGrid [data-infinite-scrolling]');
    if (!link || (link.target && link.target !== '_self') || link.hasAttribute('download')) return;
    if (loading || loadNextPage()) event.preventDefault();
  });

  observeNextPage();
  document.addEventListener('shopify:section:load', observeNextPage);
  window.addEventListener('pagehide', saveHistory);
  window.addEventListener('pageshow', restoreList);
  window.addEventListener('scroll', () => {
    if (!loadedPages || restoring) return;
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(saveHistory, 150);
  }, { passive: true });
})();
